export default (theme) => ({
  SimpleSelect__Title: {
    marginLeft: '10px',
    fontSize: '18px'
  },
  SimpleSelect__Text: {
    minWidth: '150px'
  }
})
